// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-cta[data-v-44d04c89]{display:flex;flex-direction:column;align-items:center;text-align:center;height:100%}.title[data-v-44d04c89]{font-size:1.5rem;line-height:1.8rem;font-weight:700;display:block}.address[data-v-44d04c89]{font-size:1.125rem;line-height:1.5rem;margin-bottom:23px}.btn[data-v-44d04c89]{margin-top:auto;min-width:160px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
